package com.milta.core.localization

import androidx.compose.runtime.Composable
import androidx.compose.runtime.CompositionLocalProvider
import androidx.compose.runtime.staticCompositionLocalOf
import androidx.compose.ui.text.intl.Locale
import cafe.adriel.lyricist.ProvideStrings
import cafe.adriel.lyricist.rememberStrings

/**
 * The app's currently active language tag (user-selected, not necessarily the device locale —
 * see [ProvideAppStrings]). Exposed separately from [LocalStrings] (which only carries the
 * translated string bundle) for the rare cases that need the raw tag itself, e.g. locale-aware
 * number formatting (decimal separator) where there is no dedicated screen parameter for it.
 */
val LocalLanguageTag = staticCompositionLocalOf { "en" }

@Composable
fun ProvideAppStrings(
    languageTag: String = resolveLanguageTag(Locale.current.language),
    content: @Composable () -> Unit,
) {
    val lyricist = rememberStrings(Strings, languageTag)
    lyricist.languageTag = languageTag
    ProvideStrings(lyricist, LocalStrings) {
        CompositionLocalProvider(LocalLanguageTag provides languageTag) {
            content()
        }
    }
}
